import { createAction } from 'redux-actions';

export default {
    UpdateMonitorCfg: createAction('UPDATE_MONITOR_CFG')
};
